
/* eslint-disable react/jsx-key */

import { saveAs } from "file-saver"
import { t } from "i18next"
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from "react"
import { downloadExcel } from "react-export-table-to-excel"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import {
    useFilters,
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable
} from "react-table"
import * as XLSX from "xlsx"

import Pagination from "./pagination"
import eyeIcon from "../../../assets/common/eye.svg"
import downIcon from "../../../assets/common/sort_down.svg"
import upIcon from "../../../assets/common/sort_up.svg"
import deleteIcon from "../../../assets/Hub_Icons/delete.svg"
import downloadIcon from "../../../assets/Hub_Icons/download.svg"
import editIcon from "../../../assets/Hub_Icons/edit.svg"
import filterIcon from "../../../assets/Hub_Icons/filter.svg"
import copyIcon from "../../../assets/Hub_Icons/Interactive-icon.svg"
import searchIcon from "../../../assets/Hub_Icons/search.svg"
import sortIcon from "../../../assets/Hub_Icons/sort.svg"
import { convertDateTimeByFormat, textLineClamp } from "../../../utils/utils.js"
import LanguageSelector from "../../LanguageSelector"
import ServiceCenterFilter from "../../ServiceCenterFilter"
import ToggleButton from "../../Tables/ToggleButton"
import DropDownButton from "../Form/DropdownButton/index.js"
import Dropdown from "../Form/DropdownWithSetValueSupport"
import Language from "../Language"
import Loader from "../Loader/loader"

export const GlobalFilter = ({
    globalFilter,
    setGlobalFilter,
    searchWrapperClass,
    data
}) => {

    useEffect(() => {
        setValue()
    }, [data])

    const [value, setValue] = useState(globalFilter)

    useEffect(()=>{
        if(value == "") {
            setGlobalFilter(undefined)
        }
    },[value])

    const handleSearch = () => {
        const parsedValue = (value !== "") ? value : Number(value)
        setGlobalFilter(parsedValue || undefined)
    }

    return (
        <div className="relative">
            <input
                type="Search"
                className= { `${searchWrapperClass || ""} border-lightGray border 
                    rounded-[57px] h-9 px-4 pr-12 outline-0 placeholder-secondary-50 
                    fontSize-sm focus:outline-none focus:ring-0 focus:border-primary-100 
                    focus:bg-lightSkyblue hover:border-primary-100` }
                placeholder={ t("common.search") }
                value={ value || "" }
                onChange={ e => {
                    setValue(e.target.value)
                } }
                onKeyDown={ e => {
                    if (e.key === "Enter") {
                        setValue(e.target.value)
                        handleSearch()
                    }
                } }
            />
            <button
                type="submit"
                className="absolute right-4 h-9 top-0 flex items-center justify-center"
                onClick={ handleSearch }
            >
                <img alt="search" src={ searchIcon } className="" height={ "16px" } width={ "16px" } />
            </button>
        </div>
    )
}

const ReactTable = forwardRef(({
    title,
    columns,
    data,
    translateFeature,
    serviceCenterFeature,
    dayRangeFilterFeature,
    dayRangeListData,
    dayRangeHandler,
    serviceCenterListData,
    serviceCenterHandler,
    serviceCenterDefaultValue,
    globalLanguageChange,
    downloadFeature,
    checkBoxFeature,
    downloadData,
    addNewFeature,
    customButtonFeature,
    customButton,
    filterFeature,
    onHandleToogleClick,
    isStickyColumns,
    setCurrentLanguages,
    isJsondownload,
    getDownloadData,
    isDeleteRow,
    isCountryHubAssociation,
    status,
    loader,
    disableSearch,
    handleFilterClick,
    permissionDetails,
    module,
    isStickyColumnslast2,
    isStickyColumnslast3,
    isButonURL,
    isFilteredValue,
    languageChangeHandler,
    isCustomLanguageSelector,
    copyFeature,
    renderKey,
    editDeleteColumnPermission,
    isDropdownButton,
    dropdownMenus,
    searchedValue,
    onPaginationClicked,
    isClientRowsDownload,
    isLastRowStickyDisabled,
    PaginationClass,
    isdeleteBasedOnEdit,
    ...props
}, ref) => {
    const { t } = useTranslation()
    const [editableRowIndex, setEditableRowIndex] = useState(null)
    const tableRef = useRef(null)
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        setGlobalFilter,
        state,
        prepareRow,
        selectedFlatRows,        
        gotoPage,   
        pageOptions,    
        setPageSize,
        rows,
        state: { pageSize }
    } = useTable(
        {
            columns: columns || [],
            data: data || [],
            editableRowIndex,
            setEditableRowIndex,
            initialState: { 
                pageIndex: 0
            }
        },        
        useFilters,
        useGlobalFilter,        
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks) => {
            if (checkBoxFeature || props.isCheckBoxEnabled) {
                hooks.visibleColumns.push((columns) => [
                    {
                        id: "selection",
                        Header: ({ getToggleAllRowsSelectedProps }) => (
                            <div className="text-sm font-bold text-primary-50">
                                <IndeterminateCheckbox
                                    { ...getToggleAllRowsSelectedProps() }
                                    label={ props?.checkboxlabel }
                                />
                            </div>
                        ),
                        Cell: ({ row }) => (
                            <div>
                                <IndeterminateCheckbox
                                    { ...row.getToggleRowSelectedProps() }
                                    value={ row.original.id }
                                />
                            </div>
                        )
                    },
                    ...columns
                ])
            }
        }
    )
    const IndeterminateCheckbox = forwardRef(
        ({ indeterminate, ...rest }, ref) => {
            const defaultRef = useRef()
            let resolvedRef = ref || defaultRef
            useEffect(() => {
                resolvedRef.current.indeterminate = indeterminate
            }, [resolvedRef, indeterminate])
            return (
                <>
                    <div className="flex items-center gap-1">
                        <div className="relative cursor-pointer  select-none w-[18px] h-[18px] custom-checkbox">
                            <input
                                type="checkbox"
                                className={ "peer w-[18px] h-[18px] absolute opacity-0 z-[2]" }
                                ref={ resolvedRef }
                                { ...rest }
                            />
                            <span
                                className={ `checkmark absolute h-[18px] w-[18px] bg-white 
                                    border rounded-[4px] border-primary-50 z-[1] after:absolute 
                                    after:hiddent after:content-[''] after:w-[6px] after:h-[12px] 
                                    after:rotate-45  after:border-b-[2px]  after:border-r-[2px] 
                                    after:border-white after:left-[5px] after:top-[1px] ${
                rest?.checked ? "after:block !bg-primary-50" : ""}` }
                            ></span>
                        </div>
                        { rest?.label && (
                            <label className="relative top-[3px] left-[5px]">
                                { rest.label }
                            </label>
                        ) }
                    </div>
                </>
            )
        }
    )

    

    const renderDataTable = (row, cell, index) => {
        switch (cell.column.type) {
        case "toogle": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "transparentBorderRight px-4 border-b min-h-[40px] border-secondary-300 text-sm text-secondary-50 py-1" +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white"
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white"
                          : ""
                  : "") + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && `right-0 sticky min-w-101 border-l 
                    px-4 border-gray bg-white `) + (row.cells.length - 2 === index && " right-[81px] ") ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index || row.cells.length - 2 === index 
                    || row.cells.length - 3 === index)  && " right-0 sticky v px-4  bg-white   ") 
                    + (row.cells.length - 3 === index && " right-[188px] border-l  border-gray ") 
                    + (row.cells.length - 2 === index) ))
                    }
                >
                    <div className="flex items-center flex-row-reverse justify-end gap-4">
                        { cell.render("Cell") }
                        <ToggleButton
                            value={ cell.value }
                            row={ row }
                            onHandleChange={ onHandleToogleClick }
                            disabled = { permissionDetails?._update && ((isdeleteBasedOnEdit 
                                && row?.original?.is_editable) || !isdeleteBasedOnEdit) ? false : true }
                        />
                    </div>
                </td>
            )
        }
        case "link": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white"
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white"
                          : ""
                  : "")
                    }
                >
                    { cell.render("Cell") }
                    <NavLink
                        onClick={ () => cell.column.onActionClick(row.original) }
                        className="nav-link text-sm text-primary-100"
                    >
                        { t("common.viewDetails") }
                    </NavLink>
                </td>
            )
        }
        case "status": {
            return (
                <td
                    className={
                        "transparentBorderLeft font-normal text-sm text-secondary-50 border-b border-secondary-300 text-left py-1 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky w-100 bg-white "
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white"
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && ` right-0 sticky min-w-101 border-l 
                    px-4 border-gray bg-white ") + (row.cells.length - 2 === index && " right-[81px] `) ))
                          + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                            || row.cells.length - 2 === index || row.cells.length - 3 === index)  
                            && " right-0 sticky min-w-101 px-4  bg-white   ") 
                            + (row.cells.length - 3 === index && " right-[193px] border-l  border-gray ") 
                            + (row.cells.length - 2 === index && " right-[81px]") ))
                    }
                    { ...cell.getCellProps() }
                >
                    <span
                        className={
                            "flex .text-xs p-[8px] justify-center items-center gap-[10px] pb-[4px] flex-1 rounded-md " +
                (cell?.value === "Approved" || cell?.value === true || cell?.value === t("common.ACTIVE") 
                    ? "bg-greenlight text-xs max-w-24 w-full inline-block text-center "
                    : cell?.value === "Pending" || cell?.value === false
                        ? "bg-greenyellow text-xs max-w-24 w-full inline-block text-center "
                        : "bg-lightred text-xs max-w-24 w-full inline-block text-center ")
                        }
                    >
                        { cell.render("Cell") }
                    </span>
                </td>
            )
        }
        case "edit": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 bg-white text-right " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white"
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white "
                          : ""
                  : "")  + (isStickyColumnslast2 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                    + (row.cells.length - 2 === index && " border-l border-gray right-[81px]") ))
                  + (isStickyColumnslast3 && (((row.cells.length - 1 === index 
                    || row.cells.length - 2 === index || row.cells.length - 3 === index) 
                     && " right-0 sticky w-101 bg-white ") + (row.cells.length - 3 === index 
                        && " border-l border-gray right-[193px]") ))
                    }
                >
                    <div className="flex justify-end">
                        <>
                            {
                                (row.original.version === 0 && row.original.status === "Rejected") ? (
                                    <button
                                        onClick={ ()=> cell.column.onViewClick(row.original) }
                                        className="shrink-0 p-2 rounded-full hover:border-0 
                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                    >
                                        <img
                                            src={ eyeIcon }
                                            height="14px"
                                            width="14px"
                                            alt="View"
                                            title="View"
                                        />
                                    </button> ) :
                                    ((module === "hubContinent" ||
                    module === "countryConfig" ||
                    module === "hubRegionalContinents" ||
                    module === "hubSubContinent" ||
                    module === "order_min_max" ||
                    module === "warranty_policy" ) &&
                  (!row?.original?.is_editable && row.original.status !== "Rejected" ) ? (<> </>) : 
                                        (
                                            <>
                                                { ((permissionDetails?._update && editDeleteColumnPermission)) && <button
                                                    onClick={ () => cell.column.onActionClick(row.original) }
                                                    className="shrink-0 p-2 rounded-full hover:border-0 
                                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                >
                                                    <img
                                                        src={ editIcon }
                                                        height="14px"
                                                        width="14px"
                                                        alt="Edit"
                                                        title="Edit"
                                                    />
                                                </button> } 
                                                {
                                                    !editDeleteColumnPermission && <button
                                                        onClick={ () => cell.column.onActionClick(row.original) }
                                                        className="shrink-0 p-2 rounded-full hover:border-0 
                                                    hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                    >
                                                        <img
                                                            src={ editIcon }
                                                            height="14px"
                                                            width="14px"
                                                            alt="Edit"
                                                            title="Edit"
                                                        />
                                                    </button>
                                                }
                                                { copyFeature && <button
                                                    onClick={ () => cell.column.onCopyClick(row.original) }
                                                    className="shrink-0 p-1 rounded-full hover:border-0 
                                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                                >
                                                    <img
                                                        src={ copyIcon }
                                                        height="14px"
                                                        width="14px"
                                                        alt="Copy"
                                                        title="Copy"
                                                    />
                                                </button> }
                                            </>
                                        )) }
                        </>

                        { ((isdeleteBasedOnEdit && row?.original?.is_editable) || !isdeleteBasedOnEdit) 
                        && isDeleteRow && permissionDetails?._delete && (
                            <button
                                className="shrink-0 p-2 rounded-full hover:border-0 
                                hover:bg-primary-150 transition-transform transform hover:scale-110"
                                onClick={ () => cell.column.onActionDeleteClick(row.original) }
                            >
                                <img
                                    alt="delete record"
                                    src={ deleteIcon }
                                    className=""
                                    height={ "12px" }
                                    width={ "12px" }
                                    title="Delete"
                                />
                            </button>
                        ) }
                    </div>
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? isLastRowStickyDisabled ? "" : "left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
    
        case "url": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white "
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white "
                          : ""
                  : "") + (isStickyColumnslast2 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index)  
                    && " right-0 sticky min-w-101 border-l px-4 border-gray bg-white ") 
                    + (row?.cells?.length - 2 === index && " right-[81px] ") ))
                  + (isStickyColumnslast3 && (((row?.cells?.length - 1 === index ||
                     row?.cells?.length - 2 === index || row?.cells?.length - 3 === index)  
                     && " right-0 sticky min-w-101 px-4  bg-white   ") + (row?.cells?.length - 3 === index 
                        && " right-[193px] border-l  border-gray ") 
                        + (row?.cells?.length - 2 === index && " right-[81px]") ))
                    }
                >
                    <NavLink to={ cell.value }
                        className="nav-link underline"
                    >
                        { cell.render("Cell") }
                    </NavLink>
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? isLastRowStickyDisabled ? "" : " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        case "updatedBy": {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        `${cell.column.styles ? cell.column.styles : ""} ` 
                        + "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-[2.5px] " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white "
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white "
                          : ""
                  : "") + (isStickyColumnslast2 && (((row?.cells?.length - 1 === index || row?.cells?.length - 2 === index)
                    && " right-0 sticky min-w-101 border-l px-4 border-gray bg-white ") 
                    + (row?.cells?.length - 2 === index && " right-[81px] ") ))
                  + (isStickyColumnslast3 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index || row?.cells?.length - 3 === index) 
                     && " right-0 sticky min-w-101 px-4  bg-white   ") +
                      (row?.cells?.length - 3 === index && " right-[193px] border-l  border-gray ")
                       + (row?.cells?.length - 2 === index && " right-[81px]") ))
                    }
                >
                    <div className="flex flex-col">
                        <span>{ textLineClamp(cell.value, "min-w-[120px]") }</span>{ " " }
                        <span className="text-secondary-200 text-xs">{ row?.original?.updated_at && 
                        convertDateTimeByFormat(row?.original?.updated_at) }</span>
                    </div>
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? isLastRowStickyDisabled ? "" : " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        default: {
            return (
                <td
                    { ...cell.getCellProps() }
                    className={
                        `${cell.column.styles ? cell.column.styles : ""} ` 
                        + "px-4 border-b border-secondary-300 text-sm text-secondary-50 py-2 " +
              (isStickyColumns === true
                  ? index === 0
                      ? " left-0 sticky bg-white "
                      : row.cells.length - 1 === index
                          ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-white "
                          : ""
                  : "") + (isStickyColumnslast2 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index)  
                    && " right-0 sticky min-w-101 border-l px-4 border-gray bg-white ") 
                    + (row?.cells?.length - 2 === index && " right-[81px] ") ))
                  + (isStickyColumnslast3 && (((row?.cells?.length - 1 === index 
                    || row?.cells?.length - 2 === index || row?.cells?.length - 3 === index)  
                    && " right-0 sticky min-w-101 px-4  bg-white   ") + (row?.cells?.length - 3 === index 
                        && " right-[193px] border-l  border-gray ") + (row?.cells?.length - 2 === index 
                            && " right-[81px]") ))
                    }
                >
                    { cell.render("Cell") }
                    <div
                        className={
                            "border-[#CED0D6] absolute top-0 h-fill-available" +
                (isStickyColumns === true
                    ? index === 0
                        ? " border-r right-0 "
                        : row.cells.length - 1 === index
                            ? isLastRowStickyDisabled ? "" : " border-l left-0 "
                            : ""
                    : "")
                        }
                    ></div>
                </td>
            )
        }
        }
    }

    const exportJSONToExcel = async () => {
        let result = !isClientRowsDownload ? 
            await getDownloadData(state?.globalFilter) : getDownloadData(rows)
        const worksheet = XLSX.utils.json_to_sheet(
            isCountryHubAssociation ? result.data : result
        )
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, downloadData.sheet)
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        })
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        })
        saveAs(blob, downloadData.fileName)
    }

    const handleDownloadExcel = () => {
        if (isJsondownload) {
            exportJSONToExcel()
        } else {
            downloadExcel({
                fileName: downloadData.fileName,
                sheet: downloadData.sheet
            }, tableRef.current)
        }
    }


    useImperativeHandle(
        props?.selectedRows,
        () => ({
            getSelectedRows: () => selectedFlatRows
        }),
        [selectedFlatRows]
    )

    useEffect(() => {
        if (searchedValue != undefined) {
            setGlobalFilter(searchedValue)
        }
    },[searchedValue, data])

    useImperativeHandle(ref, () => {
        return {
            handleDownloadExcel
        }
    })

    return (
        <>
            <div className="flex justify-between gap-4 items-center px-4">
                <h3 className="text-md font-black text-primary-50 flex-[1_0_0]">{ `${t(title)}` }</h3>
                <div className="flex gap-4">
                    { !disableSearch && (
                        <GlobalFilter
                            globalFilter={ state.globalFilter }
                            setGlobalFilter={ setGlobalFilter }
                            searchWrapperClass={ props?.searchWrapperClass }
                            data={ data }
                        />
                    ) }
                    { translateFeature && (
                        <div className="relative w-[152px]">
                            { !isCustomLanguageSelector && <><label className="text-xs text-secondary-200 
                            absolute bg-white z-[1] top-[-8px] left-[10px]">
                                { t("common.selectLanguage") }
                            </label><LanguageSelector setCurrentLanguages={ setCurrentLanguages } currentVal={ 12 }/> 
                            </> }
                            { isCustomLanguageSelector && <Language  changeHandler ={ languageChangeHandler }
                                globalLanguageChange={ globalLanguageChange } renderKey={ renderKey }/> }
                        </div>
                    ) }
                    { dayRangeFilterFeature && (
                        <div className="relative w-[150px]">
                            <ServiceCenterFilter dayRangeFilterFeature={ dayRangeFilterFeature } 
                                dayRangeListData = { dayRangeListData } dayRangeHandler={ dayRangeHandler } />
                        </div>
                    ) }
                    { serviceCenterFeature && (
                        <div className="relative w-[200px]">
                            <ServiceCenterFilter defaultValue={ serviceCenterDefaultValue } serviceCenterListData = { serviceCenterListData } serviceCenterHandler={ serviceCenterHandler } />
                        </div>
                    ) }
                    { downloadFeature && (
                        <div className="flex-auto">
                            <button onClick={ handleDownloadExcel } type="button">
                                <img
                                    alt="Download"
                                    src={ downloadIcon }
                                    className="relative  fill-current rounded-full border 
                                    border-primary-100 hover:border-0 hover:bg-primary-150 p-2"
                                    height={ "36px" }
                                    width={ "36px" }
                                    title="Download"
                                />
                            </button>
                        </div>
                    ) }
                    { filterFeature && (
                        <div className="flex-auto relative">
                            <button type="button" onClick={ handleFilterClick }>
                                <img
                                    alt={ t("common.filter") }
                                    src={ filterIcon }
                                    className="relative  fill-current rounded-full border 
                                    border-primary-100 hover:border-0 hover:bg-primary-150 p-2"
                                    height={ "36px" }
                                    width={ "36px" }
                                    title="Filter"
                                />
                            </button>
                            { isFilteredValue &&<span className="absolute w-[14px] h-[14px] 
                            shrink-0 border rounded-full background bg-tertiary-500 right-[0px] 
                            top-[4px] solid border-white -mt-2"></span> }
                        </div>
                    ) }
                    { addNewFeature && permissionDetails?._write && (
                        <div className="flex-auto">
                            <button
                                type="button"
                                onClick={ () => props.onAddNew() }
                                className="rounded-full w-full  bg-primary-100 text-white font-bold 
                                text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                            >
                                { isDeleteRow
                                    ? `+ ${t(`${props.buttonTitle}`)}`
                                    : isButonURL ? props.buttonTitle :  `+ ${t("common.add")} ${t(title)}` }
                            </button>
                        </div>
                    ) }
                    { isDropdownButton && dropdownMenus && permissionDetails?._write && (
                        <div className="flex-auto">
                            <DropDownButton
                                label={ props?.buttonTitle }
                                buttonWrapperClass={ props?.buttonliWrapper }
                                subMenus={ dropdownMenus }
                            />
                        </div>
                    )
                    }
                    { customButtonFeature && (
                        <div className="flex w-[240px]">
                            { customButton?.type == "Dropdown" && (
                                <Dropdown
                                    className={ "h-[35px] w-[98%] mt-0 mr-0" }
                                    value=""
                                    placeholder={ t("lms.trainingCompletionStatus") }
                                    options={ customButton.options }
                                    name="status"
                                    id="status"
                                    changeHandler={ (e) => customButton?.onChange(e.value) }
                                    isMulti={ false }
                                    isNotRequired={ true }
                                />
                            ) }
                            { customButton?.type != "Dropdown" && (
                                <button
                                    type="button"
                                    onClick={ () => customButton?.onClick() }
                                    className="flex items-center gap-[4px] rounded-full w-full 
                                    bg-primary-100 text-white font-bold text-sm  hover:bg-primary-150 
                                    hover:text-primary-50 h-9 px-4"
                                >
                                    { `${customButton?.title}` }
                                    { customButton?.icon && (
                                        <img
                                            src={ customButton?.icon }
                                            className="w-[12px] h-[12px] flex-shrink-0"
                                            alt="calendarIcon"
                                        />
                                    ) }
                                </button>
                            ) }
                        </div>
                    ) }
                </div>
            </div>

            <div className="w-full overflow-auto custome-scroll custome-scroll-x">
                <table { ...getTableProps() } ref={ tableRef } className={ "table-auto text-left w-full " 
                    + ((isStickyColumnslast2 || isStickyColumns || isStickyColumnslast3)  
                    && " border-separate border-spacing-0" ) } data-test-id={ props?.dataTestId }>
                    <thead className="bg-lightSkyblue">
                        { headerGroups.map((headerGroup) => (
                            <tr { ...headerGroup.getHeaderGroupProps() } role="row">
                                { headerGroup.headers.map((column, index) => (
                                    <th
                                        { ...column.getHeaderProps(column.getSortByToggleProps()) }
                                        className={ `${column.styles ? column.styles : ""} ` +
                                            "px-4 min-h-[42px] text-sm font-bold text-primary-50 py-[8px] " +
                      (isStickyColumns === true
                          ? index === 0
                              ? " left-0 sticky bg-lightSkyblue "
                              : headerGroup.headers.length - 1 === index
                                  ? isLastRowStickyDisabled ? "" : " right-0 sticky w-101 bg-lightSkyblue "
                                  : ""
                          : "") + (isStickyColumnslast2 && (((headerGroup.headers.length - 1 === index 
                            || headerGroup.headers.length - 2 === index)  && " right-0 sticky w-101 bg-lightSkyblue ") 
                          + (headerGroup.headers.length - 2 === index && " right-[81px] border-l border-gray ") )) + 
                          (isStickyColumnslast3 && (((headerGroup.headers.length - 1 === index 
                            || headerGroup.headers.length - 2 === index || headerGroup.headers.length - 3 === index)  
                            && " right-0 sticky w-101 bg-lightSkyblue ") 
                          + (headerGroup.headers.length - 3 === index && " right-[188px] border-l border-gray ") 
                          + (headerGroup.headers.length - 2 === index && " right-[81px] ") ) ) 
                          + ((isStickyColumns || isStickyColumnslast2 || isStickyColumnslast3) 
                          && " whitespace-nowrap ") +
                      (column.Header === "Action" ? " text-right " : "") + (((column.id === "action") 
                      && column.textRight == true) ? " text-right " : "")
                                        }
                                    >
                                        <div className="inline-flex items-center gap-2">
                                            { column.render("Header") }
                                            <span className="shrink-0">
                                                {
                                                    column.isSorted
                                                        ? column.isSortedDesc
                                                            ? <img
                                                                    src={ downIcon }
                                                                    className="text-gray-600 h-4 w-4 fill-current"
                                                                    height={ "16px" }
                                                                    width={ "16px" }
                                                                    alt="sort"
                                                            />
                                                            : <img
                                                                    src={ upIcon }
                                                                    className="text-gray-600 h-4 w-4 fill-current"
                                                                    height={ "16px" }
                                                                    width={ "16px" }
                                                                    alt="sort"
                                                            />
                                                        : column.Header?.name == "emptyRenderer" 
                                                        || column.disableSortBy ? <></> : <img
                                                                src={ sortIcon }
                                                                className="text-gray-600 h-4 w-4 fill-current"
                                                                height={ "16px" }
                                                                width={ "16px" }
                                                                alt="sort"
                                                            /> }
                                            </span>
                                        </div>
                                        <div
                                            className={
                                                "border-[#CED0D6] absolute top-0 h-fill-available" +
                        (isStickyColumns === true
                            ? index === 0
                                ? " border-r right-0 "
                                : headerGroup.headers.length - 1 === index
                                    ? isLastRowStickyDisabled ? "" : " left-0 "
                                    : ""
                            : "")
                                            }
                                        ></div>
                                    </th>
                                )) }
                            </tr>
                        )) }
                    </thead>
                    { (loader || status === "pending") && <Loader loading={ true } /> }
                    { status !== "pending" && page && page?.length === 0 ? (
                        <tr role="row">
                            <td
                                colSpan={ columns.length }
                                className="text-center	pt-5 text-#34383F text-1xl font-Avenir"
                            >
                                { t("common.noRecordsMsg") }
                            </td>
                        </tr>
                    ) : (
                        <tbody { ...getTableBodyProps() }>
                            {                                        
                                page.map((row) => {                                    
                                    prepareRow(row)
                                    return (
                                        <tr { ...row.getRowProps() } className="hover:bg-lighestgray" role="row">
                                            { row.cells.map((cell, index) => (
                                                <> { renderDataTable(row, cell, index) }</>
                                            )) }
                                        </tr>
                                    )
                                }) }
                        </tbody>
                    ) }
                </table>
            </div>
            
            {
                
                
                <div className={ `${PaginationClass} pagination noprint mt-2` }>                
                    <Pagination
                        gotoPage={ gotoPage }
                        length={ rows?.length }
                        pageSize={ pageSize }
                        setPageSize={ setPageSize }
                        pageindex= { (state?.pageIndex ? (state?.pageIndex + 1) : 1) }
                        onPaginationClicked={ onPaginationClicked }
                        paginationShow={ pageOptions.length > 1 ? true : false }
                    />
                </div>
               
            }
            
        </>
    )
})

export default ReactTable
